var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"means-chart"},[_c('svg'),_c('v-overlay',{attrs:{"absolute":true,"value":_vm.overlayValue}},[_vm._v("\n    Means chart not shown for less than 3 time periods\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }